import { assertNever } from "assert-never";
import { html, render } from "lit-html";
import Split from "split.js";

import styles from "./WorkspaceWindow.module.css";

interface WorkspaceWindow {
  root: HTMLElement;
  toolbar: HTMLElement;
  sidebar: HTMLElement;
  main: HTMLElement;
  globalNotifactionBanner: HTMLElement;
  editorTabs: HTMLElement;
  toolsPanelTabs: HTMLElement;
  toolsPanelTerminals: HTMLElement;
  toolsPanelCodeDiagnostics: HTMLElement;
  toolsPanelGhci: HTMLElement;
  editor: HTMLElement;
  statusbar: HTMLElement;
}

export function createWorkspaceWindow(): WorkspaceWindow {
  const template = html`
    <div class="${styles.root}">
      <div class="${styles.toolbar}">TOOLBAR</div>
      <div class="${styles.main}">
        <div class="${styles.sidebar}">SIDEBAR</div>
        <div class="${styles.primary}">
          <div class="${styles.primary_top}">
            <div class="${styles.global_notifaction_banner}"></div>
            <div class="${styles.editor_tabs}">EDITOR_TABS</div>
            <div class="${styles.editor}"></div>
          </div>
          <div class="${styles.tools_panel}">
            <div class="${styles.tools_panel_tabs}"></div>
            <div class="${styles.tools_panel_contents}">
              <div class="${styles.tools_panel_terminals}"></div>
              <div class="${styles.tools_panel_code_diagnostics}"></div>
              <div class="${styles.tools_panel_ghci}"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="${styles.statusbar}">STATUSBAR</div>
    </div>
  `;

  const root = document.createElement("div");
  render(template, root);

  const q = requiredQuerySelector;

  const toolbar = q(root, `.${styles.toolbar}`);
  const main = q(root, `.${styles.main}`);
  const sidebar = q(root, `.${styles.sidebar}`);
  const primary = q(root, `.${styles.primary}`);
  const primary_top = q(root, `.${styles.primary_top}`);
  const global_notifaction_banner = q(root, `.${styles.global_notifaction_banner}`);
  const editor_tabs = q(root, `.${styles.editor_tabs}`);
  const editor = q(root, `.${styles.editor}`);
  const tools_panel = q(root, `.${styles.tools_panel}`);
  const tools_panel_tabs = q(root, `.${styles.tools_panel_tabs}`);
  const tools_panel_terminals = q(root, `.${styles.tools_panel_terminals}`);
  const tools_panel_code_diagnostics = q(root, `.${styles.tools_panel_code_diagnostics}`);
  const tools_panel_ghci = q(root, `.${styles.tools_panel_ghci}`);
  const statusbar = q(root, `.${styles.statusbar}`);

  Split([sidebar, primary], {
    sizes: [15, 85],
    gutterSize: 9,
    gutter: (index, direction) => {
      const gutter = document.createElement("div");
      switch (direction) {
        case "horizontal":
          gutter.className = `${styles.gutter} ${styles.gutter_horizontal}`;
          break;
        case "vertical":
          gutter.className = `${styles.gutter} ${styles.gutter_vertical}`;
          break;
        default:
          assertNever(direction);
      }
      return gutter;
    }
  });

  Split([primary_top, tools_panel], {
    direction: "vertical",
    sizes: [75, 25],
    gutterSize: 9,
    gutter: (index, direction) => {
      const gutter = document.createElement("div");
      switch (direction) {
        case "horizontal":
          gutter.className = `${styles.gutter} ${styles.gutter_horizontal}`;
          break;
        case "vertical":
          gutter.className = `${styles.gutter} ${styles.gutter_vertical}`;
          break;
        default:
          assertNever(direction);
      }
      return gutter;
    }
    // elementStyle: (
    //     dimension,
    //     elementSize,
    //     gutterSize,
    //     index,
    // ) => {
    //     if (index === 0) {
    //         console.log(dimension, elementSize, gutterSize, index);
    //         const ph = primary.getBoundingClientRect().height;
    //         console.log("ph", ph);
    //         const height = Math.round(ph * (elementSize/100)) - 5;
    //         return {
    //             // height: `${height}px`
    //             height: `calc(${elementSize}% - 5px)`
    //         };
    //     } else {
    //         return {};
    //     }
    // }
  });

  return {
    root: root,
    toolbar: toolbar,
    sidebar: sidebar,
    main: main,
    globalNotifactionBanner: global_notifaction_banner,
    editorTabs: editor_tabs,
    editor: editor,
    toolsPanelTabs: tools_panel_tabs,
    toolsPanelTerminals: tools_panel_terminals,
    toolsPanelCodeDiagnostics: tools_panel_code_diagnostics,
    toolsPanelGhci: tools_panel_ghci,
    statusbar: statusbar
  };
}

function requiredQuerySelector(node: ParentNode, selectors: string): HTMLElement {
  const child = node.querySelector<HTMLElement>(selectors);
  if (child === null) {
    throw new Error(`Element not found: ${selectors}`);
  }
  return child;
}
